export function sending_to_upper_chamber(value) {
  return (value == "upper_chamber") ? true : false
}
export function sending_to_lower_chamber(value) {
  return (value == "lower_chamber") ? true : false
}
export function sending_to_both_chambers(value) {
  return value == "both_chambers" ? true : false
}
export function sending_to_specific_legislators(value) {
  return value == "specific_legislators" ? true : false
}